import React, { useState, useEffect, createContext, useRef } from "react";
export const ConfigContext = createContext();

const ConfigContextProvider = (props) => {
  const [config, setConfig] = useState(null);
  const [authentication_config, setAuthentication_config] = useState({});
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!config) {
      fetch(process.env.PUBLIC_URL + "/config.json")
        .then((res) => res.json())
        .then(
          (result) => {
            const selected = window.location.href.match(/dev.flou/)
              ? result.DEV
              : result.PROD;
              
            setConfig(selected);

            if (wrapperRef.current) {
              /*const parent = wrapperRef.current.parentElement;
              const grandParent = parent?.parentElement;
              
              console.log('Parent:', parent);
              console.log('Grandparent:', grandParent);*/

              setAuthentication_config ({modal:true})

              //window.AUTHENTICATION_CONFIG = {modal: false, mode:"login" };
              /*const namespace = grandParent.dataset.namespace;
              if(namespace && namespace==="modalAuth") {
                setAuthentication_config ({modal:true})
                console.log('Namespace:', namespace);
              } else if(namespace && namespace==="embedAuth") {
                setAuthentication_config ({modal:false})
                console.log('Namespace:', namespace);
              }*/
            }
          },
          (error) => {}
        );
    }
  }, []);
  return (
    <div ref={wrapperRef}>
      <ConfigContext.Provider value={{ ...config, authentication_config }}>
        {config && props.children}
      </ConfigContext.Provider>
    </div>
  );
};

export default ConfigContextProvider;
